class GiftWrappingComponent extends HTMLElement {
  constructor() {
    super();

    this.cartDrawer      = document.querySelector("m-cart-drawer");
    this.giftWrapId      = this.dataset.giftWrapId;
    this.giftWrapping    = this.dataset.giftWrapping;
    this.cartItemsSize   = parseInt(this.getAttribute("cart-items-size"));
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart"));
    this.loadingIcon     = this.querySelector(".m-gift-wrapping--loading");
    this.desiredQty      = 1; // lock to exactly 1

    // Toggle handler on checkbox
    this.querySelector('[name="attributes[gift-wrapping]"]')
      .addEventListener("change", (event) => {
        event.target.checked ? this.setGiftWrapping() : this.removeGiftWrapping();
      });

    // 1) If the cart contains *only* a single gift-wrap item, remove it:
    if (this.cartItemsSize === 1 && this.giftWrapsInCart > 0) {
      this.removeGiftWrapping();
    }
    // 2) If somehow there are >1 gift-wrap items in cart, force back to 1:
    else if (this.giftWrapsInCart > this.desiredQty) {
      this.setGiftWrapping();
    }
    // 3) If exactly 1 in cart, but attribute is out of sync (false), re-add it:
    else if (this.giftWrapsInCart === this.desiredQty && this.giftWrapping === "false") {
      this.setGiftWrapping();
    }
    // 4) If 0 in cart but attribute says “true”, add exactly 1:
    else if (this.giftWrapsInCart === 0 && this.giftWrapping === "true") {
      this.setGiftWrapping();
    }
  }

  setGiftWrapping() {
    const sectionsToUpdate = this.getSectionsToUpdate();
    this.loadingIcon.classList.add("show");

    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json"
    });
    const config = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        updates: {
          [this.giftWrapId]: this.desiredQty // always 1
        },
        attributes: { "gift-wrapping": true },
        sections: sectionsToUpdate
      })
    };

    this.updateCart(config);
  }

  removeGiftWrapping() {
    const sectionsToUpdate = this.getSectionsToUpdate();
    this.loadingIcon.classList.add("show");

    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json"
    });
    const config = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        updates: {
          [this.giftWrapId]: 0
        },
        attributes: { "gift-wrapping": false, "gift-note": "" },
        sections: sectionsToUpdate
      })
    };

    this.updateCart(config);
  }

  getSectionsToUpdate() {
    let sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", {
        bubbles: true,
        detail: { sections: sections }
      })
    );
    return sections;
  }

  updateCart(request) {
    return fetch(`${MinimogSettings.routes.cart_update_url}`, request)
      .then((response) => response.json())
      .then((response) => {
        this.loadingIcon.classList.remove("show");
        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: { cart: response }
          })
        );
      })
      .catch((e) => {
        console.error(e);
        // Always remove spinner even if error occurs
        this.loadingIcon.classList.remove("show");
      });
  }
}
customElements.define("m-gift-wrapping-component", GiftWrappingComponent);

class GiftNoteComponent extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "change",
      debounce((event) => {
        const headers = new Headers({
          "Content-Type": "application/json",
          Accept: "application/json"
        });
        const request = {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            attributes: { "gift-note": event.target.value }
          })
        };
        fetch(`${MinimogSettings.routes.cart_update_url}`, request);
      }, 300)
    );
  }
}
customElements.define("m-gift-note-component", GiftNoteComponent);

class GiftWrappingQuantityInput extends MQuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.giftWrapping    = document.querySelector("m-gift-wrapping-component");
    this.cartItemsSize   = parseInt(this.getAttribute("cart-items-size"));
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart"));
    this.desiredQty      = 1;

    // 1) If the only thing in cart is a gift-wrap item, remove it:
    if (this.cartItemsSize === 1 && this.giftWrapsInCart > 0) {
      this.giftWrapping.removeGiftWrapping();
    }
    // 2) If there are >1 gift-wrap items, force back to 1:
    else if (this.giftWrapsInCart > this.desiredQty) {
      this.update();
    }
    // 3) If exactly 1 gift-wrap in cart but component is missing (attribute out of sync), force:
    else if (this.giftWrapsInCart === this.desiredQty && !this.giftWrapping) {
      this.update();
    }
    // 4) If 0 in cart but component exists (attribute is true), force:
    else if (this.giftWrapsInCart === 0 && this.giftWrapping) {
      this.update();
    }
  }

  update() {
    this.input.value = this.desiredQty; // always 1
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("m-gift-wrapping-input", GiftWrappingQuantityInput);
